import buildComponent from './utils/build-component';
import checkIntersection from './utils/check-intersection';

export default (nameSpace, selector) => buildComponent({
  nameSpace,
  selector,
  initState: {
    isInView: false,
    mediaQuery: false,
  },
  initFunction: ($el, params) => {
    const $imageLandscape = $el.querySelector(`.${nameSpace}__svg--is-landscape .${nameSpace}__image`)
    const $imagePortrait = $el.querySelector(`.${nameSpace}__svg--is-portrait .${nameSpace}__image`)

    //
    // Methods
    //

    function setMediaQuery() {
      if (
        window.innerWidth > window.innerHeight &&
        params.getState().mediaQuery !== 'landscape'
      ) {
        params.setState({ mediaQuery: 'landscape'})
      } else if (
        window.innerWidth <= window.innerHeight &&
        params.getState().mediaQuery !== 'portrait'
      ) {
        params.setState({ mediaQuery: 'portrait'})
      }
    }

    //
    // Life Cycle
    //

    params.onStateUpdate((newState, prevState) => {
      if (newState.isInView) {
        if (
          newState.mediaQuery === 'landscape' &&
          !$imageLandscape.getAttributeNS('http://www.w3.org/1999/xlink', 'href')
        ) {
          $imageLandscape.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', $imageLandscape.dataset.href);
        } else if (
          newState.mediaQuery === 'portrait' &&
          !$imagePortrait.getAttributeNS('http://www.w3.org/1999/xlink', 'href')   
        ) {
          $imagePortrait.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', $imagePortrait.dataset.href);
        }
      }
    });

    //
    // Procedures
    //

    checkIntersection($el, () => {
      params.setState({ isInView: true });
    })

    setMediaQuery()

  }
});



// WEBPACK FOOTER //
// ./src/scripts/editorial-full-picture.js